<template>
    <div class="float-left mr-1">
        <span class="text-primary">
            <i
                class="fa fa-edit fa-lg icon-button"
                title="Atualizar Dotação Orçamentária"
                @click.stop="abrirModal()"
            ></i>
        </span>
        <inserir-atualizar-dotacao-em-massa-form
            acao="ATUALIZAR"
            :mostrarModal="mostrarModal"
            @modalFechado="mostrarModal = false"
            :percentualTotal="percentualTotal"
            :percentualDisponivel="percentualDisponivel"
            :rateio="rateio"
            @atualizarRateio="$emit('atualizarRateio', $event)"
            @obterUnidades="$emit('obterUnidades')"
            @obterProjetos="$emit('obterProjetos', $event)"
            @obterAcoes="$emit('obterAcoes', $event)"
            :unidades="unidades"
            :projetos="projetos"
            :acoes="acoes"
        ></inserir-atualizar-dotacao-em-massa-form>
    </div>
</template>

<script>
import InserirAtualizarDotacaoEmMassaForm from './InserirAtualizarDotacaoEmMassaForm'

export default {
    components: {
        InserirAtualizarDotacaoEmMassaForm
    },

    props: {
        rateio: {
            type: Object,
            default: () => {}
        },

        percentualTotal: {
            type: Number,
            default: () => 0
        },

        percentualDisponivel: {
            type: Number,
            default: () => 0
        },

        unidades: {
            type: Array
        }, 

        projetos: {
            type: Array
        }, 
        
        acoes: {
            type: Array
        }
    },

    data() {
        return {
            mostrarModal: false
        }
    },

    methods: {
        abrirModal() {
            this.mostrarModal = true
        }
    },

    created() {},

    computed: {},

    watch: {},

    validations: {}
}
</script>
